import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'quartz-routing';
import { getHostRouteDefinitions } from './granite-config';
import { ErrorPage } from '../components/ErrorPage';
import { getGraniteRuntime } from './GraniteRuntime';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function GraniteRouterBase({
  getRoutes = getHostRouteDefinitions,
  children
}) {
  const {
    remoteModules,
    localRouteOverrides
  } = useMemo(() => getRoutes(), [getRoutes]);
  const history = useHistory();
  const runtime = getGraniteRuntime();
  const containerRef = useRef(null);
  const [error, setError] = useState(null);
  const [activeAppName, setActiveAppName] = useState(() => {
    runtime.initialize(remoteModules, localRouteOverrides);
    return runtime.getRemoteForPath(history.location.pathname);
  });
  useEffect(() => {
    return runtime.startListening(history, () => containerRef.current, {
      onAppActive: appName => setActiveAppName(appName),
      onLocalActive: () => setActiveAppName(null),
      onError: setError
    });
  }, [history, runtime]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [error && /*#__PURE__*/_jsx(ErrorPage, {
      error: error
    }), /*#__PURE__*/_jsx("div", {
      ref: containerRef
    }), !activeAppName && !error && children]
  });
}
export const GraniteRouter = /*#__PURE__*/memo(GraniteRouterBase);